module.exports = __webpack_public_path__ + "img/2-1.e81c48e4.jpg";